module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iCiAgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cgo8c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZlcnNpb249IjEuMSIKICAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoKICA8cmVjdCB4PSIyMCIgeT0iMjAiIHdpZHRoPSIyNTAiIGhlaWdodD0iMjUwIgogICAgICAgIHN0eWxlPSJmaWxsOmJsdWU7c3Ryb2tlOnBpbms7c3Ryb2tlLXdpZHRoOjU7CmZpbGwtb3BhY2l0eTowLjE7c3Ryb2tlLW9wYWNpdHk6MC45Ii8+Cgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ../~/picidae-theme-haier/pages/style/anchor.svg
// module id = 909
// module chunks = 26